export type PositionKey = 1 | 2 | 3 | 4 | 5 | 6;

export interface PositionConfig {
    anchorOrigin: {
        vertical: 'top' | 'bottom';
        horizontal: 'left' | 'center' | 'right';
    };
    transitionDirection: 'up' | 'down' | 'left' | 'right';
}

export const positions: Record<PositionKey, PositionConfig> = {
    1: {
        anchorOrigin: { vertical: 'top', horizontal: 'left' },
        transitionDirection: 'right',
    },
    2: {
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
        transitionDirection: 'down',
    },
    3: {
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        transitionDirection: 'left',
    },
    4: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
        transitionDirection: 'left',
    },
    5: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
        transitionDirection: 'up',
    },
    6: {
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transitionDirection: 'right',
    },
};
